export function addMultipleEventListener(element, events, handler) {
    events.forEach(e => element.addEventListener(e, handler))
}